var module = angular.module('octopusApp.environments');

module.directive('machineStatus', function(){
    return {
        restrict: 'E',
        replce: true,
        scope: {
            machine : '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: function($scope, targetStateMapper) {
            var self = this;
            this.calculateTargetIcon = function calculateTargetIcon() {
                return targetStateMapper.calculateTargetIcon(self.machine);
            };
        },
        template: '<div class="machine-status" ng-if="vm.machine">' +
        '   <img style="height: 1.5em" alt="{{::vm.machine.statusSummary}}" title="{{::vm.machine.statusSummary}}" ng-src="{{::vm.calculateTargetIcon()}}">' +
        '</div>'
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/machine_status.js
// module id = 7063573135545238
// module chunks = 1